import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";
import { IBaseUrl } from "../..";

const MemberCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState("");
  const [photoPreview, setPhotoPreview] = useState(null);
  const [formData, setFormData] = useState({
    member_code: "",
    registered_at: "",
    full_name: "",
    dob: "",
    gender: "",
    mobile: "",
    whatsapp: "",
    alternate_phone: "",
    email: "",
    aadhaar_no: "",
    pan_no: "",
    is_aadhaar_verified: 0,
    is_pan_verified: 0,
    nominee_name: "",
    nominee_relation: "",
    nominee_phone: "",
    photo: "",
    aadhaar_photo: "",
    pan_photo: "",
    address_proof_photo: "",
    cibil_score: "",
    cibil_report_date: "",
    permanent_address: "",
    permanent_city: "",
    permanent_district: "",
    permanent_state: "",
    permanent_pincode: "",
    current_address: "",
    current_city: "",
    current_district: "",
    current_state: "",
    current_pincode: "",
    marital_status: "",
    occupation: "",
    annual_income: "",
    remarks: "",
    notes: "",
    branch_id: "",
    created_by: "",
    status: "",
    source: "", // e.g. 'Online'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const handleSelect = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhotoChange = (e) => {
    const { name, files } = e.target;
    const file = files?.[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        console.log("Base64 result:", reader.result);
        setPhotoPreview((prev) => ({ ...prev, [name]: reader.result }));
        setFormData((prev) => ({ ...prev, [name]: reader.result }));
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({ ...prev, [name]: null }));
      setPhotoPreview((prev) => ({ ...prev, [name]: null }));
    }
  };

  const fetchDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const result = await fetchFormData("member/get-by-id", formData, "POST");

      if (result && result.data == 200) {
        const member = result.data;
        setFormData(result.data);
        console.log(member);
      }
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      setFormData("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create a FormData object
    const formMemeber = new FormData();
    formMemeber.append("branchID", 1);
    formMemeber.append("member_code", formData.member_code);
    formMemeber.append("registered_at", formData.registered_at);
    formMemeber.append("full_name", formData.full_name);
    formMemeber.append("dob", formData.dob);
    formMemeber.append("gender", formData.gender);
    formMemeber.append("mobile", formData.mobile);
    formMemeber.append("whatsapp", formData.whatsapp);
    formMemeber.append("email", formData.email);
    formMemeber.append("aadhaar_no", formData.aadhaar_no);
    formMemeber.append("pan_no", formData.pan_no);
    formMemeber.append("is_aadhaar_verified", formData.is_aadhaar_verified);
    formMemeber.append("is_pan_verified", formData.is_pan_verified);
    formMemeber.append("nominee_name", formData.nominee_name);
    formMemeber.append("nominee_relation", formData.nominee_relation);
    formMemeber.append("nominee_phone", formData.nominee_phone);
    formMemeber.append("aadhaar_photo", formData.aadhaar_photo);
    formMemeber.append("photo", formData.photo);
    formMemeber.append("pan_photo", formData.pan_photo);
    formMemeber.append("address_proof_photo", formData.address_proof_photo);
    formMemeber.append("cibil_score", formData.cibil_score);
    formMemeber.append("cibil_report_date", formData.cibil_report_date);
    formMemeber.append("permanent_address", formData.permanent_address);
    formMemeber.append("permanent_city", formData.permanent_city);
    formMemeber.append("permanent_district", formData.permanent_district);
    formMemeber.append("permanent_state", formData.permanent_state);
    formMemeber.append("permanent_pincode", formData.permanent_pincode);
    formMemeber.append("current_address", formData.current_address);
    formMemeber.append("current_city", formData.current_city);
    formMemeber.append("current_district", formData.current_district);
    formMemeber.append("current_state", formData.current_state);
    formMemeber.append("current_pincode", formData.current_pincode);
    formMemeber.append("marital_status", formData.marital_status);
    formMemeber.append("occupation", formData.occupation);
    formMemeber.append("annual_income", formData.annual_income);
    formMemeber.append("remarks", formData.remarks);
    formMemeber.append("notes", formData.notes);
    formMemeber.append("branch_id", formData.branch_id);
    formMemeber.append("created_by", formData.created_by);
    formMemeber.append("status", formData.status);

    try {
      let res;

      if (id) {
        formMemeber.append("id", id);
        res = await fetchFormData("member/update", formMemeber, "POST");
        console.log("Updating member:", formMemeber);
      } else {
        res = await fetchFormData("add-member", formMemeber, "POST");
        console.log("Creating new memeber:", formData);
      }

      if (res && res.code === 200) {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate("/member/member-list");
        console.log(" operation successful", res);
      } else if (res && res.message === "Status updated") {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate("/member/member-list");
        console.log(" operation successful", res);
      } else {
        console.error(" operation failed", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Lender:" : "Add Member:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit} className="row g-3">
              <div className="col-md-6">
                <Input
                  label="Member Code"
                  name="member_code"
                  value={formData.member_code}
                  onChange={handleChange}
                  placeholder="Member Code"
                  icon="feather-hash"
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="Registered"
                  name="registered_at"
                  type="date"
                  value={formData.registered_at}
                  onChange={handleChange}
                  placeholder="Registered "
                  icon="feather-file-text"
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="Full Name"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  placeholder="Full Name "
                  icon="feather-user"
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="Date of Birth"
                  name="dob"
                  type="date"
                  value={formData.dob}
                  onChange={handleChange}
                  placeholder="Date of Birth "
                  icon="feather-clock"
                  required
                />
              </div>
              <div className="col-md-6">
                <div className="form-group d-flex">
                  <div className="col-md-4">
                    <label htmlFor="gender" className="fw-semibold">
                      Gender <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-8">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="fa fa-users"></i> {/* Correct class */}
                      </span>
                      <select
                        className="form-control"
                        name="gender"
                        id="gender"
                        value={formData.gender}
                        onChange={handleSelect}
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <Input
                  label="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Mobile Number "
                  icon="feather-smartphone"
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  placeholder="Whatsapp Number "
                  icon="feather-message-square"
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="alternate_phone"
                  name="alternate_phone"
                  value={formData.alternate_phone}
                  onChange={handleChange}
                  placeholder="Alternate Phone Number "
                  icon="feather-phone"
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email "
                  icon="feather-link"
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="Aadhaar No"
                  name="aadhaar_no"
                  value={formData.aadhaar_no}
                  onChange={handleChange}
                  placeholder="Aadhaar No"
                  icon="feather-hash"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="PAN No"
                  name="pan_no"
                  value={formData.pan_no}
                  onChange={handleChange}
                  placeholder="PAN No"
                  icon="feather-hash"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Aadhaar Verified"
                  name="is_aadhaar_verified"
                  value={formData.is_aadhaar_verified}
                  onChange={handleChange}
                  placeholder="Aadhaar Verified"
                  icon="feather-check-circle"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="PAN Verified"
                  name="is_pan_verified"
                  value={formData.is_pan_verified}
                  onChange={handleChange}
                  placeholder="PAN Verified"
                  icon="feather-check-circle"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Nominee Name"
                  name="nominee_name"
                  value={formData.nominee_name}
                  onChange={handleChange}
                  placeholder="Nominee Name"
                  icon="feather-user"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Nominee Relation"
                  name="nominee_relation"
                  value={formData.nominee_relation}
                  onChange={handleChange}
                  placeholder="Nominee Relation"
                  icon="feather-users"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Nominee Phone"
                  name="nominee_phone"
                  value={formData.nominee_phone}
                  onChange={handleChange}
                  placeholder="Nominee Phone"
                  icon="feather-phone"
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="Photo"
                  name="photo"
                  type="file"
                  onChange={handlePhotoChange}
                  placeholder="Upload Photo"
                  icon="fa-cc-mastercard"
                />
              </div>
              {photoPreview && (
                <img
                  src={photoPreview.photo}
                  alt="Preview"
                  style={{ width: "100px", height: "100px" }}
                />
              )}

              <div className="col-md-6">
                <Input
                  label="Aadhaar Photo"
                  name="aadhaar_photo"
                  type="file"
                  onChange={handlePhotoChange}
                  placeholder="Upload Photo"
                  icon="fa-cc-mastercard"
                />
              </div>
              {photoPreview && (
                <img
                  src={photoPreview.aadhaar_photo}
                  alt="Preview"
                  style={{ width: "100px", height: "100px" }}
                />
              )}
              <div className="col-md-6">
                <Input
                  label="Pan Photo"
                  name="pan_photo"
                  type="file"
                  onChange={handlePhotoChange}
                  placeholder="Upload Photo"
                  icon="fa-cc-mastercard"
                />
              </div>
              {photoPreview && (
                <img
                  src={photoPreview.pan_photo}
                  alt="Preview"
                  style={{ width: "100px", height: "100px" }}
                />
              )}
              <div className="col-md-6">
                <Input
                  label="Address Proof Photo"
                  name="address_proof_photo"
                  type="file"
                  onChange={handlePhotoChange}
                  placeholder="Upload Photo"
                  icon="fa-cc-mastercard"
                />
              </div>
              {photoPreview && (
                <img
                  src={photoPreview.address_proof_photo}
                  alt="Preview"
                  style={{ width: "100px", height: "100px" }}
                />
              )}

              <div className="col-md-6">
                <Input
                  label="CIBIL Score"
                  name="cibil_score"
                  value={formData.cibil_score}
                  onChange={handleChange}
                  placeholder="CIBIL Score"
                  icon="feather-bar-chart-2"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="CIBIL Report Date"
                  name="cibil_report_date"
                  type="date"
                  value={formData.cibil_report_date}
                  onChange={handleChange}
                  icon="feather-date"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Permanent Address"
                  name="permanent_address"
                  value={formData.permanent_address}
                  onChange={handleChange}
                  placeholder="Permanent Address"
                  icon="feather-home"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Permanent City"
                  name="permanent_city"
                  value={formData.permanent_city}
                  onChange={handleChange}
                  placeholder="Permanent City"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Permanent District"
                  name="permanent_district"
                  value={formData.permanent_district}
                  onChange={handleChange}
                  placeholder="Permanent District"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Permanent State"
                  name="permanent_state"
                  value={formData.permanent_state}
                  onChange={handleChange}
                  placeholder="Permanent State"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Permanent Pincode"
                  name="permanent_pincode"
                  value={formData.permanent_pincode}
                  onChange={handleChange}
                  placeholder="Permanent Pincode"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Current Address"
                  name="current_address"
                  value={formData.current_address}
                  onChange={handleChange}
                  placeholder="Current Address"
                  icon="fa-home"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Current City"
                  name="current_city"
                  value={formData.current_city}
                  onChange={handleChange}
                  placeholder="Current City"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Current District"
                  name="current_district"
                  value={formData.current_district}
                  onChange={handleChange}
                  placeholder="Current District"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Current State"
                  name="current_state"
                  value={formData.current_state}
                  onChange={handleChange}
                  placeholder="Current State"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Current Pincode"
                  name="current_pincode"
                  value={formData.current_pincode}
                  onChange={handleChange}
                  placeholder="Current Pincode"
                  icon="feather-map-pin"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Marital Status"
                  name="marital_status"
                  value={formData.marital_status}
                  onChange={handleChange}
                  placeholder="Marital Status"
                  icon="fa-users"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Occupation"
                  name="occupation"
                  value={formData.occupation}
                  onChange={handleChange}
                  placeholder="Occupation"
                  icon="feather-clipboard"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Annual Income"
                  name="annual_income"
                  value={formData.annual_income}
                  onChange={handleChange}
                  placeholder="Annual Income"
                  icon="feather-dollar-sign"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  placeholder="Remarks"
                  icon="feather-edit"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Notes"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  icon="feather-file-text"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Branch ID"
                  name="branch_id"
                  value={formData.branch_id}
                  onChange={handleChange}
                  placeholder="Branch ID"
                  icon="feather-hash"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Created By"
                  name="created_by"
                  value={formData.created_by}
                  onChange={handleChange}
                  placeholder="Created By"
                  icon="feather-user-check"
                  required
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Status"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  placeholder="Status"
                  icon="feather-activity"
                />
              </div>
              <div className="col-md-12">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary d-flex text-center"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default MemberCreate;
